import type { Rule } from "antd/es/form";

export function isNonNegativeNumber(value: unknown, integer = false): boolean {
  return typeof value === "number" && Number.isFinite(value) && value >= 0 &&
    (!integer || Number.isSafeInteger(value));
}

export function nonNegativeRules(label: string, integer = false, required = false): Rule[] {
  return [
    { required, message: `请输入${label}` },
    {
      validator: (_rule: unknown, value: unknown): Promise<void> => {
        if (value == null || value === "" || isNonNegativeNumber(value, integer)) return Promise.resolve();
        return Promise.reject(new Error(integer ? `${label}必须为非负整数` : `${label}必须为大于或等于 0 的有效数字`));
      },
    },
  ];
}
